import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface NotificationBellProps {
  unreadCount: number;
  onClick: () => void;
}

export function NotificationBell({ unreadCount, onClick }: NotificationBellProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative h-9 w-9"
      onClick={onClick}
    >
      <Bell className={cn(
        "h-5 w-5",
        unreadCount > 0 && "text-primary"
      )} />
      {unreadCount > 0 && (
        <Badge 
          variant="destructive" 
          className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center text-[10px]"
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
      <span className="sr-only">Notificações</span>
    </Button>
  );
}
